import React from "react";
import { ShipmentStatus, TodayOrder } from "../../../assets/img";
import { ArrowDownIcon, ArrowUpIcon } from "@heroicons/react/24/outline";

const Status = ({
  todayWarehouseStatus,
  shipmentStatus,
  todayOrderStatus,
  todaySalesStatus,
  hospitalStatus,
  patientStatus,
}) => {
  const hospitalTodayIncrease = hospitalStatus?.todayIncrease ?? 0;
  const hospitalTodayDecrease = hospitalStatus?.todayDecrease ?? 0;
  const patientTodayIncrease = patientStatus?.todayIncrease ?? 0;
  const patientTodayDecrease = patientStatus?.todayDecrease ?? 0;

  const hospitalTodayDifference = hospitalTodayIncrease - hospitalTodayDecrease;
  const patientTodayDifference = patientTodayIncrease - patientTodayDecrease;

  return (
    <div className="flex shadow-dashboard px-6 py-8 justify-between">
      <div className="flex items-center">
        <div>
          <img className="w-[46px]" src={ShipmentStatus} alt="" />
        </div>
        <div className="ml-2">
          <p className="text-[#8D8D8D]">오늘 입고현황</p>
          <p className="text-lg font-bold">{todayWarehouseStatus}</p>
        </div>
      </div>
      <div className="flex items-center">
        <div>
          <img className="w-[46px]" src={ShipmentStatus} alt="" />
        </div>
        <div className="ml-2">
          <p className="text-[#8D8D8D]">오늘 출고현황</p>
          <p className="text-lg font-bold">{shipmentStatus}</p>
        </div>
      </div>
      <div className="flex items-center">
        <div>
          <img className="w-[46px]" src={TodayOrder} alt="" />
        </div>
        <div className="ml-2">
          <p className="text-[#8D8D8D]">오늘 주문서 접수</p>
          <p className="text-lg font-bold">{todayOrderStatus}</p>
        </div>
      </div>
      <div className="flex items-center">
        <div>
          <img className="w-[46px]" src={ShipmentStatus} alt="" />
        </div>
        <div className="ml-2">
          <p className="text-[#8D8D8D]">오늘 총 매출</p>
          <p className="text-lg font-bold">{todaySalesStatus}</p>
        </div>
      </div>
      <div className="flex items-center">
        <div>
          <img className="w-[46px]" src={ShipmentStatus} alt="" />
        </div>
        <div className="ml-2">
          <p className="text-[#8D8D8D]">총 가입자 (병원 · 환자)</p>
          <p className="text-lg flex font-bold">
            {hospitalStatus?.total ?? 0}
            <span className="text-[12px] flex ml-1.5 text-secondary-blue">
              {hospitalTodayDifference > 0 ? (
                <ArrowUpIcon width={10} />
              ) : (
                <ArrowDownIcon width={10} />
              )}{" "}
              {Math.abs(hospitalTodayDifference)}
            </span>
            <span className="mx-1">·</span>
            {patientStatus?.total ?? 0}
            <span className="text-[12px] flex ml-1.5 text-secondary-red">
              {patientTodayDifference > 0 ? (
                <ArrowUpIcon width={10} />
              ) : (
                <ArrowDownIcon width={10} />
              )}{" "}
              {Math.abs(patientTodayDifference)}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Status;
